// Mavon's AJAX product forms use novalidate. Validate this template explicitly
// in the capture phase, before the existing product-form submit handler.
(() => {
  if (window.srAnyVendorSampleInstalled) return;
  window.srAnyVendorSampleInstalled = true;
  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-sr-sample-request]')) {
      event.target.setCustomValidity('');
    }
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = Array.from(form.elements).find((element) =>
      element.matches('[data-sr-sample-request]'));
    if (!input) return;
    input.value = input.value.trim();
    input.setCustomValidity(input.value ? '' : 'Please enter the sample SKU or product name.');
    if (!input.checkValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.focus();
      input.reportValidity();
    }
  }, true);
})();
